import React from "react";
import "../dashboard/Dashboard.css";

const ChangeIndicator = ({ change }) => {
  if (change === null || change === undefined) return null;
  if (change === "new") return <span className="stat-change stat-change--new">New</span>;
  if (change === 0) return <span className="stat-change stat-change--flat">No change</span>;

  const isUp = change > 0;
  return (
    <span className={`stat-change ${isUp ? "stat-change--up" : "stat-change--down"}`}>
      {isUp ? "▲" : "▼"} {Math.abs(change)}% from last period
    </span>
  );
};

const StatsGrid = ({ stats = {}, changes = {} }) => {
  const statsArray = React.useMemo(() => {
    if (Array.isArray(stats)) return stats;

    return [
      {
        label: "Search Visibility",
        value: stats.visibilityRate || "0%",
        colorClass: "home-visibility-card",
        change: changes.visibilityRate,
      },
      {
        label: "Profile Views",
        value: stats.pageVisitors || 0,
        colorClass: "home-visitors-card",
        change: changes.pageVisitors,
      },
      {
        label: "Whatsapp Enquiries",
        value: stats.whatsappClicks || 0,
        colorClass: "home-clicks-card",
        change: changes.whatsappClicks,
      },
    ];
  }, [stats, changes]);

  return (
    <div className="home-stats-grid">
      {statsArray.map((stat, index) => (
        <div key={index} className={`stat-card ${stat.colorClass || ""}`}>
          <p className="label">{stat.label}</p>
          <p className="value">{stat.value}</p>
          <ChangeIndicator change={stat.change} />
        </div>
      ))}
    </div>
  );
};

export default StatsGrid;